import { logoImg1, logoImg4, logoImg3, logoImg2 } from "../assets/image"

export const config = {
  DEBUG: true,

  BACKEND_URL: process.env.REACT_APP_BASE_BACKEND,
  FRONTEND_URL: process.env.REACT_APP_BASE_FRONTEND,

  // projectName: "Genstar",
  // jpProjectName: "ジェンスター",

  stripe: {
    publishkey: process.env.REACT_APP_STRIPE_PUBLISHKEY || "",
  }
}

export const lectureTypes: SelectitemData[] = [
  {
    value: "robots",
    label: "Robots",
  }, {
    value: "computer_it",
    label: "Computer/IT",
  }, {
    value: "ai",
    label: "AI",
  }, {
    value: "radio",
    label: "Radio",
  }, {
    value: "engineering",
    label: "Engineering",
  }, {
    value: "english",
    label: "English",
  },
  {
    value: "interest",
    label: "Gens Interest",
  },
]
// nodemailer: {
//   host: process.env.SMTP_HOST,
//   port: process.env.SMTP_PORT,
//   user: process.env.SMTP_USER,
//   pass: process.env.SMTP_PASS,
//   from: process.env.SMTP_FROM,
// },
export const languageLists: LanguageObject[] = [
  {
    label: "English",
    value: "en",
  }, {
    label: "Japanese",
    value: "jp",
  }
]

const logoOptions = [
  { value: 1, image: logoImg1 },
  { value: 2, image: logoImg2 },
  { value: 3, image: logoImg3 },
  { value: 4, image: logoImg4 },
]

export const getLogoImage = (value: number) => {
  return logoOptions.find(option => option.value === value)?.image || logoImg1;
}